import { useEffect, useRef, useState } from 'react';
import { galleryCategories, localAsset } from './galleryData';

export function DesignGallery() {
  const dialogRef = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const element = dialogRef.current;
    if (!element) return;
    if (active) {
      element.showModal();
    } else if (element.open) {
      element.close();
    }
  }, [active]);

  return (
    <>
      <dialog
        ref={dialogRef}
        className="lightbox"
        aria-label="Enlarged design"
        onClose={() => setActive(null)}
        onClick={(event) => {
          if (event.target === dialogRef.current) setActive(null);
        }}
      >
        {active ? (
          <div className="lightbox-inner" onClick={(event) => event.stopPropagation()}>
            <img src={active.src} alt={active.alt} className="lightbox-img" />
            <button type="button" className="lightbox-close" onClick={() => setActive(null)}>
              Close
            </button>
          </div>
        ) : null}
      </dialog>

      <div className="design-gallery">
        {galleryCategories.map((category) => (
          <section
            key={category.id}
            className="gallery-category"
            id={`gallery-${category.id}`}
            aria-labelledby={`heading-${category.id}`}
          >
            <h3 className="gallery-category-title" id={`heading-${category.id}`}>
              {category.title}
            </h3>
            <p className="gallery-category-desc">{category.description}</p>
            <ul className={`gallery-grid gallery-grid--${category.frameRatio || 'square'}`}>
              {category.items.map((item) => {
                const src = localAsset(item.path);
                const thumbMode = category.thumbMode || 'cover';

                if (item.kind === 'video') {
                  return (
                    <li key={item.path} className="gallery-cell gallery-cell--video">
                      <div className="gallery-video-wrap">
                        <video
                          controls
                          preload="metadata"
                          className="gallery-video"
                          title={item.label}
                        >
                          <source src={encodeURI(src)} type="video/mp4" />
                        </video>
                      </div>
                      <span className="gallery-caption">{item.label}</span>
                    </li>
                  );
                }

                return (
                  <li key={item.path} className="gallery-cell">
                    <button
                      type="button"
                      className={`gallery-thumb gallery-thumb--${thumbMode} gallery-thumb--${
                        category.frameRatio || 'square'
                      }`}
                      onClick={() => setActive({ src, alt: `${item.label} - design sample` })}
                    >
                      <span className="gallery-thumb-frame">
                        <img
                          src={src}
                          alt={`${item.label} - design sample`}
                          loading="lazy"
                          decoding="async"
                          className="gallery-thumb-img"
                        />
                        <span className="gallery-thumb-shade" aria-hidden />
                      </span>
                      <span className="gallery-caption">{item.label}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
      </div>
    </>
  );
}
